import { render, staticRenderFns } from "./ServicesHair.vue?vue&type=template&id=4045416e&lang=pug&"
import script from "./ServicesHair.vue?vue&type=script&lang=ts&"
export * from "./ServicesHair.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports